import React from "react";
import { Card, Typography } from "antd";
import { useLanguage } from "src/providers/LanguageProvider";

const { Text } = Typography;

type InvoiceProfile = {
  CompanyName?: string;
  CompanyAddress?: string;
  CompanyPostalCode?: string;
  CompanyCity?: string;
  CompanyCountry?: string;
  TaxNumber?: string;
};

type Props = { profile?: InvoiceProfile | null };

function joinNonEmpty(parts: Array<string | undefined | null>, sep = ", ") {
  return parts.filter(Boolean).join(sep);
}

const BuyLicenseInvoiceMiniCard: React.FC<Props> = ({ profile }) => {
  const { t } = useLanguage();

  return (
    <Card size="small" bodyStyle={{ padding: 12 }}>
      <Text type="secondary">{t("INVOICE_BILLED_TO")}</Text>
      <div style={{ marginTop: 6 }}>
        {profile ? (
          <div>
            {profile.CompanyName && (
              <div style={{ fontWeight: 600 }}>{profile.CompanyName}</div>
            )}

            <div style={{ fontSize: 12, opacity: 0.85 }}>
              {joinNonEmpty([profile.CompanyAddress, profile.CompanyPostalCode])}
            </div>

            <div style={{ fontSize: 12, opacity: 0.85 }}>
              {joinNonEmpty([profile.CompanyCity, profile.CompanyCountry])}
            </div>

            {profile.TaxNumber && (
              <div style={{ fontSize: 12, opacity: 0.7 }}>
                {t("INVOICE_TAX_NUMBER_SHORT")}: {profile.TaxNumber}
              </div>
            )}
          </div>
        ) : (
          <Text type="secondary">{t("NOT_SELECTED")}</Text>
        )}
      </div>
    </Card>
  );
};

export default BuyLicenseInvoiceMiniCard;
